import React, { FunctionComponent, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useAtom } from 'jotai';

import {
  Avatar,
  Box,
  Grid,
  InputAdornment,
  TextField
} from '@mui/material';

import { loginAtom } from '../../lib/auth';

import ErrorIcon from '@mui/icons-material/Error';

var he = require('he');

type StyledTextFieldTranslProps = {
  sx?: object;
  label: string;
  value: {nl:string, fr:string};
  activeLocale: 'nl' | 'fr';
  fullWidth?: boolean;
  error?: boolean;
  id: string;
  helperText?: string|React.ReactNode;
  type?: string;
  multiline?: boolean;
  errorArray?: string[];
  onChange: (z:{nl:string, fr:string}) => void;
};

export const StyledTextFieldTransl: FunctionComponent<StyledTextFieldTranslProps> = ({label, onChange, sx, error, value, id, type, multiline, fullWidth, errorArray, helperText, activeLocale}) => {
  const theme = useTheme();

  const [login, setLogin] = useAtom(loginAtom);

  const [editorContent, setEditorContent] = useState<string>(value[activeLocale] || value.nl || '');
  const [editorContentNl, setEditorContentNl] = useState<string>(value.nl);
  const [editorContentFr, setEditorContentFr] = useState<string>(value.fr);
  const [inited, setInited] = useState<boolean>(false);

  let setting_languages_split_raw = '0';
  if (!!login && !!login.extra_data?.settings?.languages_split) setting_languages_split_raw = login.extra_data.settings.languages_split;
  let setting_languages_split = (setting_languages_split_raw === "1");

  return (<>
    {!!setting_languages_split && <>
      <Grid item xs={12}>
        <TextField
          value={value.nl}
          helperText={helperText}
          id={id}
          error={!!errorArray && errorArray.indexOf(id) > -1}
          type={type}
          variant="outlined"
          multiline={multiline}
          label={`${he.decode(label)} (NL)`}
          onChange={(e) => {onChange({...value, nl: e.target.value})}}
          sx={{
            ...(fullWidth ? {
              width: '100%',
              paddingTop: 1,
              paddingBottom: 1
            } : {
              width: 'auto',
              padding: 1
            }),
            'input': {
              padding: 1
            },
            'label[data-shrink=true]': {
              left: fullWidth ? 0 : 8,
              top: 8
            },
            'label[data-shrink=false]': {
              opacity: 0.4
            },
            ...sx
          }}
          InputProps={{
            endAdornment: !!error ?(<InputAdornment position="end">
              <ErrorIcon style={{color: '#d32f2f'}} />
            </InputAdornment>) : null
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          value={value.fr}
          helperText={helperText}
          id={id}
          error={!!errorArray && errorArray.indexOf(id) > -1}
          type={type}
          variant="outlined"
          multiline={multiline}
          label={`${he.decode(label)} (FR)`}
          onChange={(e) => {onChange({...value, fr: e.target.value})}}
          sx={{
            ...(fullWidth ? {
              width: '100%',
              paddingTop: 1,
              paddingBottom: 1
            } : {
              width: 'auto',
              padding: 1
            }),
            'input': {
              padding: 1
            },
            'label[data-shrink=true]': {
              left: fullWidth ? 0 : 8,
              top: 8
            },
            'label[data-shrink=false]': {
              opacity: 0.4
            },
            ...sx
          }}
          InputProps={{
            endAdornment: !!error ?(<InputAdornment position="end">
              <ErrorIcon style={{color: '#d32f2f'}} />
            </InputAdornment>) : null
          }}
        />
      </Grid>
    </>}
    
    {!setting_languages_split && <Box sx={{position: 'relative', width: '100%'}}>
      <Avatar
        sx={{position: 'absolute', top: -4, right: 32, zIndex: 999, width: 24, height: 24, fontSize: '0.8rem', backgroundColor: ((value['nl'] || '').replace(/<\/?[^>]+(>|$)/g, "") === '' ? 'red' : theme.palette.tertiary?.main)}}
      >NL</Avatar>
      <Avatar
        sx={{position: 'absolute', top: -4, right: 4, zIndex: 999, width: 24, height: 24, fontSize: '0.8rem', backgroundColor: ((value['fr'] || '').replace(/<\/?[^>]+(>|$)/g, "") === '' ? 'red' : theme.palette.tertiary?.main)}}
      >FR</Avatar>
      <TextField
        value={value[activeLocale] || ''}
        helperText={helperText}
        id={id}
        error={!!errorArray && errorArray.indexOf(id) > -1}
        type={type}
        variant="outlined"
        multiline={multiline}
        label={he.decode(label)}
        onChange={(e) => {onChange({...value, [activeLocale]: e.target.value})}}
        sx={{
          ...(fullWidth ? {
            width: '100%',
            paddingTop: 1,
            paddingBottom: 1
          } : {
            width: 'auto',
            padding: 1
          }),
          'input': {
            padding: 1
          },
          'label[data-shrink=true]': {
            left: fullWidth ? 0 : 8,
            top: 8
          },
          'label[data-shrink=false]': {
            opacity: 0.4
          },
          ...sx
        }}
        InputProps={{
          endAdornment: !!error ?(<InputAdornment position="end">
            <ErrorIcon style={{color: '#d32f2f'}} />
          </InputAdornment>) : null
        }}
      />
    </Box>}
  </>);
}